import { Box, styled } from '@mui/material';

// STYLED COMPONENT
const StyledLoading = styled('div')({
    // width: "100%",
    // height: "100%",
    // display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
        height: '53px',
        width: '53px',
    },
    '& .circleProgress': {
        position: 'absolute',
        left: -5,
        right: 0,
        top: 'calc(50% - 22.2px)',
    },
});

export default function SideNavLogo() {
    return (
        <StyledLoading>
            <Box position="relative">
                <img src="/assets/images/salon_logo.png" alt="" />
            </Box>
        </StyledLoading>
    );
}
